export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.13bcfbf0a880ca413c40.worker.js");
}
